module.exports = __webpack_public_path__ + "static/Twitter-f60c1ebf4179beb9d0cd13e910604a13.png";